import React, { Component } from "react";
import auth from "../../services/authService";
import { Link } from "react-router-dom";
import Table from "../../components/common/table";
import Like from "../../components/common/like";
import Delete from "../../components/common/delete";
import PaymentStatus from "../../components/common/paymentStatus";
import { downloadReceiptPdf } from "../../services/invoiceService";
import { toast } from "react-toastify";


class PaymentsTable extends Component {
  columns = [
    { 
      path: "status", 
      content: payment => <PaymentStatus status={payment.status} />
    },
    {
      path: "transid",
      label: "Transaction ID",
      content: payment => (
        <Link
          to={{
            pathname: `/payments/${payment.transid}`,
            state: { filters: this.props.filters }
          }}
        >
          {payment.transid}
        </Link>
      )
    },
    { 
      path: "account", 
      label: "Account",
      content: payment => <Link to={`/accounts/${payment.account}`}>{payment.account}</Link>
    },
    { 
      path: "amount", 
      label: "Amount", 
    },
    {
      path: "paid",
      label: "Payment Date",
      content: payment => payment.paid
    },
    {
      key: "pdf",
      label: "",
      content: (payment) => (
        Number(payment.status) >= 2 ? (
          <button
            type="button"
            className="btn btn-link btn-sm p-0"
            onClick={async () => {
              try {
                const label = payment.receiptnum || payment.transid;
                await downloadReceiptPdf(payment.transid, `receipt-${label}.pdf`);
              } catch (ex) {
                toast.error("Failed to download receipt PDF.");
              }
            }}
          >
            <i className="fa fa-file-pdf-o" /> PDF
          </button>
        ) : null
      ),
    },
  ];

  likeColumn = {
    key: "like",
    content: payment => (
      <Like liked={payment.liked} onClick={() => this.props.onLike(payment)} />
    )
  }  

  deleteColumn = {
    key: "delete",
    content: payment => (
      <Delete onClick={() => this.props.onDelete(payment)} />
    )
  };

  constructor() {
    super();
    const user = auth.getCurrentUser();
    if (user && user.role && user.role === "Manager") this.columns.push(this.likeColumn);
    if (user && user.role && user.role === "Administrator") this.columns.push(this.deleteColumn);
  }

  render() {
    const { payments, onSort, sortColumn } = this.props;

    return (
      <Table
        columns={this.columns}
        data={payments}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default PaymentsTable;
